import React, { useContext, useRef, useState } from 'react';
import { Select } from 'antd';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import Scrollbars from 'react-custom-scrollbars';
import ReactToPrint from 'react-to-print';
import moment from 'moment';
import noPhotoAvailable from '../../static/images/library/noPhotoAvailable.png';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

const getFieldDropDowns = (data) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/library/getOpac', {
			params: { ...data },
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.opacData[0];
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

const getBookDetails = (data) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/library/getBook', {
			params: { ...data },
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

let filterTypeDrops = ['All', 'Title', 'Author', 'Subjects', 'Call No', 'Accession No', 'Contents'];
export const Movements = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const [state, setState] = React.useState({});

	const componentRef = useRef();
	const { data = [] } = useQuery(['movementData', state.searchType, state.searchValue], getFieldDropDowns({ collegeId, searchType: state.searchType, searchValue: state.searchValue }), { keepPreviousData: true });

	const { data: allData = [], refetch } = useQuery(['bookData', state.bookStocksId], getBookDetails({ collegeId, bookStocksId: state.bookStocksId }), { keepPreviousData: true });

	let bookData = allData?.bookDetails;
	let circulation = allData?.circulation;

	const [loading, setLoading] = useState(false);

	const { Option } = Select;

	return (
		<Main title='Movement' className='flex flex-1 items-center justify-center bg-opacity-70 absolute left-0 top-0 right-0 bottom-0 z-[790]'>
			<Header className='absolute right-[12%] top-[2%] w-[80%] h-[60px] px-2 flex items-center justify-between gap-3 overflow-auto whitespace-nowrap'>
				<div className='flex items-center gap-3 w-full max-w-[75%] min-w-[400px]'>
					<Input2 type='text' fieldName={`Search by ${state?.searchType || 'All'}`} returnKey='searchValue' state={state} setState={setState} className='w-full' />
					<div className='flex items-center justify-end gap-2 whitespace-nowrap'>
						<Button type='refresh' onClick={() => refetch()}>
							Reload
						</Button>

						<Button type='print' tableRef={componentRef.current}>
							Print
						</Button>
						<Instruction keyId={'movements'} />
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</div>
			</Header>

			<Body className='w-[97%] h-[97%] bg-[#f2f2f2] rounded-[25px] overflow-scroll'>
				{loading ? (
					<LoadingAnimation dark />
				) : (
					<>
						<div className='flex flex-col lg:flex-row w-full p-3 mt-[38px] gap-4'>
							<div className='w-full lg:w-[400px]'>
								<div className='flex flex-col h-full w-full rounded-[25px] p-[1%] overflow-x-auto'>
									<div className='min-w-[600px]'>
										<Table width='100%' innerWidth={['5%', '20%', '50%', '20%', '20%']}>
											<Thead>
												<Tr>
													<Th position={0} fontSize='12px' textAlign='center'>
														Sn
													</Th>
													<Th position={1} fontSize='12px' textAlign='center'>
														M No
													</Th>
													<Th position={2} fontSize='12px'>
														Name
													</Th>
													<Th position={3} fontSize='10px' textAlign='center'>
														Class
													</Th>
													<Th position={4} fontSize='10px' textAlign='center'>
														Status
													</Th>
												</Tr>
											</Thead>

											<Tbody height='600px'>
												{data?.data?.map((item, i) => (
													<Tr
														key={i}
														index={i}
														onClick={() => {
															setState({ ...state, bookStocksId: item._id });
															refetch();
														}}
														border='1px solid black'>
														<Td index={i} position={0} textAlign='center' highlight={item.status !== 'available' ? '#ff8f87' : undefined}>
															{i + 1}
														</Td>
														<Td index={i} position={1} textAlign='center' highlight={item.status !== 'available' ? '#ff8f87' : undefined}>
															{item.accessionNumber}
														</Td>
														<Td index={i} position={2} highlight={item.status !== 'available' ? '#ff8f87' : undefined}>
															{item.nameOfBook}
														</Td>
														<Td index={i} position={3} textAlign='center' fontSize='10px' highlight={item.status !== 'available' ? '#ff8f87' : undefined}>
															{item.nameOfAuthor}
														</Td>
														<Td index={i} position={4} textAlign='center' fontSize='10px' highlight={item.status !== 'available' ? '#ff8f87' : undefined}>
															{item.status}
														</Td>
													</Tr>
												))}
											</Tbody>
										</Table>
									</div>
								</div>
							</div>

							<div className='w-full lg:w-[880px]'>
								<div className='w-full flex flex-col sm:flex-row rounded-[25px] p-[1%] gap-4'>
									<div className='w-full sm:w-[70%]'>
										{[
											['Title', bookData?.nameOfBook],
											['Author', bookData?.nameOfAuthor],
											['Publisher', bookData?.nameOfPublisher],
											['Edition', bookData?.edition],
											['ISBN', bookData?.isbn],
											['Accession Number', bookData?.accessionNumber],
											['Status', bookData?.status],
										].map(([label, value], idx) => (
											<div key={idx} className='flex flex-row'>
												<h5 className='mt-1.5 text-slate-800 dark:text-slate-100 text-left text-sm w-[35%] sm:w-[20%]'>{label}</h5>
												<h5 className='mt-1.5 text-slate-800 dark:text-slate-100 text-left text-sm w-[5%]'>:</h5>
												<h5 className='mt-1.5 text-slate-800 dark:text-slate-100 text-left text-sm w-[60%]'>{value}</h5>
											</div>
										))}
									</div>

									<div className='w-full sm:w-[30%] h-full'>
										<div className='h-full w-full self-center rounded-[10%]'>
											<img src={bookData?.photoURL || noPhotoAvailable} className='h-full w-full self-center rounded-[10%]' />
										</div>
									</div>
								</div>

								<Scrollbars className='max-w-full overflow-x-auto'>
									<div ref={componentRef} className='printable'>
										<img className='hidden print:block absolute w-[80%] mt-[350px] ml-[100px] mr-[200px] opacity-[0.12] -z-10' src={selectedCollege?.logo} alt='College Logo watermark' />

										<div className='w-full flex flex-col rounded-[25px] p-[1%]'>
											<div className='w-full flex flex-row rounded-[25px] m-16'>
												<img className='w-[12%] h-[12%]' src={selectedCollege?.logo} alt='College Logo' />
												<div className='w-[80%] items-center m-0 text-center'>
													<span className='text-[30px] m-0 font-black dark:text-slate-200'>{selectedCollege?.collegeShortName}</span>
													<p className='text-[25px] m-0 font-black dark:text-slate-200'>{selectedCollege?.accreditedGrade}</p>
													<p className='text-sm m-0 font-black dark:text-slate-200'>
														{selectedCollege?.address}, Phone: {selectedCollege?.phoneNumber}
													</p>
												</div>
											</div>
											<Table width='100%' innerWidth={['5%', '10%', '20%', '20%', '23%', '23%']}>
												<Thead>
													<Tr>
														{['Sn', 'M.No', 'Name', 'Class/Dept', 'Is. On', 'Rt. On'].map((label, idx) => (
															<Th key={idx} position={idx} fontSize='10px' textAlign={idx < 3 ? 'left' : 'center'}>
																{label}
															</Th>
														))}
													</Tr>
												</Thead>
												<Tbody height='auto'>
													{circulation?.map((item, i) => (
														<Tr key={i} index={i} bgColor={item.status === 'renew' ? '#c0faeb' : 'white'}>
															<Td position={0} index={i} textAlign='center'>
																{i + 1}
															</Td>
															<Td position={1} index={i}>
																{item.admisionNo}
															</Td>
															<Td position={2} index={i}>
																{item.userName}
															</Td>
															<Td position={3} index={i}>
																{item.position}
															</Td>
															<Td position={4} index={i}>
																{item.tookOn}
															</Td>
															<Td position={5} index={i}>
																{item.returnOn}
															</Td>
														</Tr>
													))}
												</Tbody>
											</Table>

											<h5 className='mt-3 text-right text-black text-[10px]'>Seal & Signature {moment(new Date()).format('DD MMM YYYY hh:mm A')}</h5>
										</div>
									</div>
								</Scrollbars>
							</div>
						</div>
					</>
				)}
			</Body>
		</Main>
	);
};
